export default __webpack_public_path__ + "static/media/room1.fb3f8df3.jpg";